<template>
  <div>
    <div class="placeholder"></div>
    <div class="tabbar-box">
      <van-tabbar
        v-model="active"
        active-color="#200E32"
        inactive-color="#a6a0ad"
        route
      >
        <van-tabbar-item replace to="/home">
          <span>My page</span>
          <template #icon="props">
            <img
              :src="props.active ? iconMypage.active : iconMypage.inactive"
            />
          </template>
        </van-tabbar-item>
        <van-tabbar-item replace to="/group">
          <span>Group</span>
          <template #icon="props">
            <img :src="props.active ? iconGroup.active : iconGroup.inactive" />
          </template>
        </van-tabbar-item>
        <van-tabbar-item replace to="/targets">
          <span>Targets</span>
          <template #icon="props">
            <img
              :src="props.active ? iconTargets.active : iconTargets.inactive"
            />
          </template>
        </van-tabbar-item>
        <van-tabbar-item>
          <span>Rewards</span>
          <template #icon="props">
            <img
              :src="props.active ? iconRewards.active : iconRewards.inactive"
            />
          </template>
        </van-tabbar-item>
      </van-tabbar>
    </div>
  </div>
</template>

<script>
export default {
  name: "Tabbar",
  data() {
    return {
      active: 0,
      iconMypage: {
        active: require("@/assets/image/tabbar/my-page-checked.png"),
        inactive: require("@/assets/image/tabbar/my-page.png"),
      },
      iconGroup: {
        active: require("@/assets/image/tabbar/group-checked.png"),
        inactive: require("@/assets/image/tabbar/group.png"),
      },
      iconTargets: {
        active: require("@/assets/image/tabbar/targets-checked.png"),
        inactive: require("@/assets/image/tabbar/targets.png"),
      },
      iconRewards: {
        active: require("@/assets/image/tabbar/rewards-checked.png"),
        inactive: require("@/assets/image/tabbar/rewards.png"),
      },
    };
  },
  methods: {
    // onChange(index) {
    //   console.log(index);
    //   switch (index) {
    //     case 0:
    //       break;
    //     case 1:
    //       this.$router.replace("/home");
    //       break;
    //     case 2:
    //       this.$router.replace("/group");
    //       break;
    //     case 3:
    //       this.$router.replace("/targets");
    //       break;

    //     default:
    //       break;
    //   }
    // },
    // tabbarSwitch(pages){
    //   console.log('asdasdasdasds',pages);
    //   var pages = '/'+pages
    //     console.log('asdasdasdasds111111111',pages);
    //   this.$router.push(pages)
    // },
  },
};
</script>

<style scoped>
.placeholder {
  height: 70px;
}
.tabbar-box {
  position: fixed;
  width: 100%;
  bottom: 0px;
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.15);
  margin-top: 100px;
}
</style>
